import { Button, Checkbox, Form, Input, InputNumber, message, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { CloseCircleOutlined } from "@ant-design/icons";
import { LogMonitor } from "@/controls";

const Ctrl = ({ id, onClose, companyId }) => {
  const defaultItem = { companyId, sn: "", vid: 0, active: true, name: "", fw: "", deadlineSec: 0, cardType: 0 };
  const [item, setItem] = useState(defaultItem);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const vidOptions = [
    { label: "Unknown", value: 0 },
    { label: "Z5rnet", value: 1 }
  ];

  const cardTypeOptions = [
    { label: "Без кодирования", value: 0 },
    { label: "XXXXXX123456 -> 123456", value: 1 }
  ];

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`CompanyCtrl/${id}`)
        .then(data => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
    else {
      form.setFieldsValue(defaultItem);
    }
  }

  useEffect(getData, [id, form, companyId])

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  };

  const onSave = () => {
    if (!id) return; // Редактирование только существующих записей
    setLoading(true);
    const payload = { 
      id: item.id,
      companyId: item.companyId,
      sn: item.sn,
      vid: item.vid,
      name: item.name,
      active: item.active,
      deadlineSec: item.deadlineSec || 0,
      cardType: item.cardType || 0
    };
    serverFetch("CompanyCtrl", { method: "PUT", bodyData: payload })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onCancel = () => onClose()

  const onDelete = () => {
    if (!id) return;
    setLoading(true);
    serverFetch(`CompanyCtrl/${id}`, { method: "DELETE" })
      .then(() => {
        setLoading(false);
        onClose(true);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Контроллер</span>
          <CloseCircleOutlined className="sport-section-title-close" onClick={onCancel} />
        </div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
          <Form.Item name="active" valuePropName="checked" label=" ">
            <Checkbox>Активный</Checkbox>
          </Form.Item>
          {item.sn && (
            <Form.Item label="Серийный номер">
              <Input value={item.sn} disabled />
            </Form.Item>
          )}
          <Form.Item label="Название" name="name">
            <Input placeholder="Название контроллера" />
          </Form.Item>
          <Form.Item label="Время ожидания (сек)" name="deadlineSec">
            <InputNumber min={0} placeholder="Время ожидания прохода в секундах" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Вид кода карты" name="cardType">
            <Select options={cardTypeOptions} />
          </Form.Item>
          {item.vid !== undefined && (
            <Form.Item label="Вид">
              <Input value={vidOptions.find(o => o.value === item.vid)?.label || item.vid} disabled />
            </Form.Item>
          )}
          {id && item.fw && (
            <Form.Item label="Версия прошивки">
              <Input value={item.fw} disabled />
            </Form.Item>
          )}
          {id && item.lastSync && (
            <Form.Item label="Последняя синхронизация">
              <Input value={new Date(item.lastSync).toLocaleString("ru-RU")} disabled />
            </Form.Item>
          )}
          {id && item.ipSync && (
            <Form.Item label="IP синхронизации">
              <Input value={item.ipSync} disabled />
            </Form.Item>
          )}
          {id && item.createdOn && (
            <Form.Item label="Дата создания">
              <Input value={new Date(item.createdOn).toLocaleString("ru-RU")} disabled />
            </Form.Item>
          )}
          <Form.Item label=" ">
            <Space>
              <Button className="sport-btn" onClick={onSave} loading={loading}>Сохранить</Button>
              {id && <LogMonitor vid={19} id={id} />}
              {id && (<Button className="sport-btn" danger onClick={onDelete} loading={loading}>Удалить</Button>)}
              <Button className="sport-btn" onClick={onCancel}>Закрыть</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  </div>
}

export default Ctrl;

